window.isModalInformationShow = true;

$(window).on('load',function(){
  if (window.isModalInformationShow) {
    $('#modalInformation').modal('show');
    window.isModalInformationShow = false
  }
});
